/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class OnboardAzureSourceAccountInteractiveRequestSubscriptionsInner {
  /**
  * Azure subscription ID
  */
  'subscriptionId': string;
  /**
  * Subscription display name
  */
  'name'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return OnboardAzureSourceAccountInteractiveRequestSubscriptionsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

